export default __webpack_public_path__ + "static/media/icon-create-account-lg.f8264def.svg";